// --------------------- Import Global ---------------------
import axios from "axios";
import Globais from "../components/Globais";

export const buscarEmpreendimentosComCidadeService = async () => {
  const URL = `${Globais.DOMINIOBACK}/empreendimento/comCidades/comEstados`;
  try {
    const response = await axios.get(URL);
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};
